import React from 'react';
import { observer } from 'mobx-react';
import Items from './items';

const AllHotels = observer(() => {
  return <Items />;
});

export default AllHotels;
